module.exports = __webpack_public_path__ + "img/people.7815cb9c.svg";